/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'

import { ROUTE_TYPE } from '../../Configuration'
import Logo from '../../assets/images/logo.svg'
import { MetadataContext } from '../../store/metadata-context-provider'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import { UserContext } from '../../store/user-context-provider'
import './menus.css'

interface Menuitems {
  activepath?: any
  icon?: any
  map?: any
  name?: any
  path?: any
  ref?: any
  submenus?: any
}
const Menus = (props: any) => {
  const {
    allMPF,
    isAssignedComponentOwner,
    isHigherMPF,
    isMAJCOMOwner,
    isSectionOwner,
    thirdLevelPermission,
  } = useContext(RoleContext)
  const { clearFilterValues } = useContext(MetadataContext)
  const { multiplePopup, setMultiplePopup } = useContext(UserContext)
  const [isOpen, setIsOpen] = useState(false)
  const [menuToHighlight, setMenuToHighlight] = useState<string>('')
  const toggle = () => {
    setIsOpen(!isOpen)
    props?.setIsMenuExpanded(!isOpen)
  }
  const [windowSize, setWindowSize] = useState(getWindowSize())
  const location = useLocation()
  const { pathname, state } = location
  const splitLocation = pathname.split('/')
  const home = useRef(null)
  const form = useRef(null)
  const inquiries = useRef(null)
  const myinquiries = useRef(null)
  const dueouts = useRef(null)
  const completedinquiries = useRef(null)
  const archivedinquiries = useRef(null)
  const calendar = useRef(null)
  const knowledgebase = useRef(null)
  const qa = useRef(null)
  const quicklinks = useRef(null)
  const announcements = useRef(null)
  const poc = useRef(null)
  const pmg = useRef(null)
  const surveyreport = useRef(null)
  const surveyreportform = useRef(null)
  const pii = useRef(null)
  const settings = useRef(null)
  const sitefeedback = useRef(null)
  const releasenotes = useRef(null)

  const { currentPage } = useContext(PreviousPageContext)

  function getWindowSize() {
    const { innerHeight, innerWidth } = window
    return { innerHeight, innerWidth }
  }
  const menuitem: Menuitems = [
    {
      activepath: ['home', 'sitefeedback'],
      icon: 'icon-dashboard2',
      name: 'Dashboard',
      path: '/',
      ref: home,
    },
    {
      activepath: ['inquiry', 'createdueout'],
      icon: 'icon-create',
      name: 'Create',
      path: '/createinquiry',
      ref: form,
      submenus: [
        {
          name: 'Inquiry',
          path: '/createinquiry',
        },
        {
          activepath: ['dueout'],
          name: 'Due Out',
          path: '/createdueout',
          show: allMPF && !isAssignedComponentOwner && !isMAJCOMOwner,
        },
      ],
    },
    {
      activepath: ['inquiries'],
      icon: 'icon-requirements',
      name: 'Inquiries',
      path: '/inquiries',
      ref: inquiries,
      show: allMPF,
    },
    {
      activepath: ['myinquiries'],
      icon: 'icon-dueouts font-15',
      name: 'My Inquiries / Due Outs',
      path: '/myinquiries-dueouts',
      ref: myinquiries,
      show: allMPF,
    },

    {
      activepath: ['dueouts'],
      icon: 'icon-dueoutsmenuicon font-16',
      name: 'Due Outs',
      path: '/dueouts',
      ref: dueouts,
      show: allMPF,
    },

    {
      activepath: ['completedinquiries'],
      icon: 'icon-completedinquiries font-15',
      name: 'Completed Inquiries',
      path: '/completedinquiries',
      ref: completedinquiries,
      show: allMPF,
    },
    {
      activepath: ['archivedinquiries'],
      icon: 'icon-archivedinquiries',
      name: ' Archived Inquiries',
      path: '/archivedinquiries',
      ref: archivedinquiries,
      show: allMPF,
    },
    {
      activepath: ['calendar'],
      icon: 'icon-menucalendar',
      name: ' Calendar',
      path: '/calendar',
      ref: calendar,
    },
    {
      activepath: ['knowledgebase'],
      icon: 'icon-knowledge-graph',
      name: ' Knowledge Base',
      path: '/knowledgebase',
      ref: knowledgebase,
    },
    {
      activepath: ['qa'],
      icon: 'icon-qa',
      name: ' Q&A',
      path: '/qanda',
      ref: qa,
    },
    {
      activepath: ['quicklinks'],
      icon: 'icon-quicklinks2',
      name: ' Quick Links',
      path: '/quicklinks',
      ref: quicklinks,
    },
    {
      activepath: ['announcements'],
      icon: 'icon-announcements',
      name: 'Announcements',
      path: '/announcements',
      ref: announcements,
    },
    {
      activepath: ['poc'],
      icon: 'icon-poc',
      name: 'Points of Contact',
      path: '/pointsofcontact',
      ref: poc,
    },
    {
      activepath: ['pmg'],
      icon: 'icon-pmg',
      name: 'Policy Memos & Guidelines',
      path: '/policymemos-guidelines',
      ref: pmg,
    },
    {
      activepath: ['pii'],
      icon: 'icon-pii',
      name: 'PII',
      path: '/pii',
      ref: pii,
      show: isHigherMPF,
    },
    {
      activepath: ['surveyreport'],
      icon: 'icon-suvey',
      name: 'Survey Report',
      path: '/surveyreport',
      ref: surveyreport,
      show: thirdLevelPermission || isSectionOwner,
    },
    {
      activepath: ['settings'],
      icon: 'icon-menusettings',
      name: 'Settings',
      path: '/settings',
      ref: settings,
      show: isHigherMPF,
    },
    {
      activepath: ['Site Feedback'],
      icon: 'icon-feedback font-15',
      name: 'Site Feedback',
      path: '/sitefeedback',
      ref: sitefeedback,
    },
    {
      activepath: ['Release Notes'],
      icon: 'icon-Checklisticon font-12',
      name: 'Release Notes',
      path: '/releasenotes',
      ref: releasenotes,
    },
  ]
  
  function activeClass(item: { activepath?: { toString: () => string }[]; path: string }) {
    let isChecked = false
    if (splitLocation[1] === 'detailview' || splitLocation[1] === 'dueoutdetailview') {
      if (item.path === state?.prevPath || (!state?.prevPath && item.path === menuToHighlight)) {
        return (isChecked = true)
      }
    } else if (item.activepath && currentPage === `/${item.activepath[0]}`) {
      return (isChecked = true)
    } else if (item?.activepath) {
      item?.activepath.forEach((element) => {
        if (splitLocation[1] === item.path || splitLocation[1] === element) {
          isChecked = true
        }
      })
      return isChecked
    }
  }

  useEffect(() => {
    const menuToHighlight = sessionStorage.getItem('menuToHighlight')
    setMenuToHighlight(menuToHighlight || '')
    setTimeout(() => {
      sessionStorage.removeItem('menuToHighlight')
    }, 5000)
  }, [])

  useEffect(() => {
    if (windowSize.innerWidth > 2000) {
      setIsOpen(true)
    } else {
      setIsOpen(false)
    }
  }, [windowSize])

  useEffect(() => {
    setMultiplePopup()
  }, [pathname])

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)
    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])
  return (
    <div className={isOpen ? 'menus menuexpand' : 'menus menucollapsed'}>
      <div className='container'>
        <div className='sidebar'>
          <div className='sidebar-logo'>
            <Link className='p-0' title=' RhyBus Customer Portal' to={`${ROUTE_TYPE}`}>
              {/* Below code for local */}
              <img
                alt=' RhyBus Customer Portal'
                aria-label='RhyBus Customer Portal'
                src={Logo}
                tabIndex={0}
                title=' RhyBus Customer Portal'
              />
            </Link>
          </div>
          <div
            className={
              isOpen
                ? 'ms-auto maxfitcontent whitetext p-2 toggle-icon icon-expand1'
                : 'ms-auto maxfitcontent whitetext p-2 toggle-icon icon-collapsed'
            }
            onClick={toggle}
            onKeyDown={toggle}
            tabIndex={0}
            title={isOpen ? 'Collapse' : 'Expand'}
          ></div>
          <ul>
            {menuitem.map((item: any, index: number) => {
              if (item.show || item.show === undefined) {
                return (
                  <li key={item.name}>
                    <NavLink
                      activeclassname='active'
                      className={activeClass(item) ? 'link active' : 'link'}
                      exact
                      key={index}
                      onClick={() => clearFilterValues()}
                      ref={item.ref}
                      title={item.name}
                      to={item.path}
                    >
                      <div className={item.icon}></div>
                      <div className='menuitems'>{item.name}</div>
                    </NavLink>
                    {item.submenus && (
                      <div
                        className='submenus'
                        style={isOpen ? {} : { top: item.ref?.current?.offsetTop }}
                      >
                        {item.submenus?.map((submenu: any, index: number) => {
                          if (submenu.show || submenu.show === undefined) {
                            return (
                              <NavLink
                                activeclassname='active'
                                className={activeClass(submenu) ? 'link active' : 'link'}
                                exact
                                key={index}
                                onClick={() => clearFilterValues()}
                                title={submenu.name}
                                to={submenu.path}
                              >
                                <div className='menuitems'>{submenu.name}</div>
                              </NavLink>
                            )
                          }
                        })}
                      </div>
                    )}
                  </li>
                )
              }
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}
export default Menus
